import styled from '@emotion/styled';
import { N30A, N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SkeletonBox = styled.div({
  boxSizing: 'border-box',
  minHeight: '38px',
  flexBasis: '100%',
  color: "var(--ds-text, ".concat(N800, ")"),
  margin: "var(--ds-space-050, 4px)".concat(" 0 ", "var(--ds-space-050, 4px)", " 0px"),
  border: "1px solid ".concat("var(--ds-border, ".concat(N30A, ")")),
  borderRadius: '3px',
  padding: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ContentSkeleton = styled(SkeletonBox)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ContentFailureMessage = styled.p({
  fontStyle: 'italic',
  userSelect: 'none'
});